import React from "react";
import Layout from "../components/common/Layout";

const TermsAndConditions = () => {
  return (
    <Layout>
      <section className="relative min-h-screen text-white overflow-hidden">
        <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20 backdrop-blur-md">
          <div className="bg-white/90 dark:bg-[#112626]/90 rounded-xl shadow-xl p-10 max-w-4xl text-gray-800 dark:text-gray-100 text-justify">
            <div className="container mx-auto p-6 max-w-4xl">
              <h1 className="text-3xl font-bold mb-6 text-center">TERMS AND CONDITIONS</h1>
              <p className="mb-4 text-center">Last updated: 27/02/2025</p>

              <h2 className="text-2xl font-semibold mt-6">1. Introduction</h2>
              <p className="mb-4">
                These Terms and Conditions govern the use of the website and platform provided by Slowork S.L. By accessing or using this website, you agree to be bound by these terms.
              </p>

              <h2 className="text-2xl font-semibold mt-6">2. Company Information</h2>
              <ul className="list-disc pl-6 mb-4">
                <li><strong>Owner:</strong> Slowork S.L</li>
                <li><strong>Registered Address:</strong> Rodrigo Caro 7, Sevilla, 41004</li>
                <li><strong>CIF/NIF:</strong> B75950444</li>
                <li><strong>Email:</strong> sloworking.adm@gmail.com</li>
                <li><strong>Phone:</strong> +34 692390453</li>
                <li><strong>Website:</strong> www.slowork.app</li>
              </ul>

              <h2 className="text-2xl font-semibold mt-6">3. Platform Use</h2>

              <h3 className="text-xl font-semibold mt-4">3.1. Eligibility</h3>
              <p className="mb-4">
                Users must be at least 18 years old and have legal capacity to enter into contracts in order to use this platform.
              </p>

              <h3 className="text-xl font-semibold mt-4">3.2. User Responsibilities</h3>
              <p className="mb-4">
                Users agree to use the platform lawfully and respectfully. Any misuse that harms the company or third parties is strictly prohibited.
              </p>

              <h3 className="text-xl font-semibold mt-4">3.3. Account and Security</h3>
              <p className="mb-4">
                Users are responsible for maintaining the confidentiality of their login credentials and for all activities that occur under their account.
              </p>

              <h3 className="text-xl font-semibold mt-4">3.4. Booking Conditions</h3>
              <p className="mb-4">
                Bookings are subject to the specific conditions of each service provider. Slowork acts solely as an intermediary and is not liable for incidents involving third-party providers.
              </p>

              <h2 className="text-2xl font-semibold mt-6">4. Intellectual Property</h2>
              <p className="mb-4">
                All content on this platform is protected by intellectual and industrial property laws. Any unauthorized use, reproduction, or distribution is strictly prohibited.
              </p>

              <h2 className="text-2xl font-semibold mt-6">5. Limitation of Liability</h2>
              <ul className="list-disc pl-6 mb-4">
                <li>Slowork is not liable for user misuse of the platform.</li>
                <li>We do not guarantee uninterrupted access to the website.</li>
                <li>We are not responsible for third-party links or services.</li>
                <li>We do not assume responsibility for disputes with providers.</li>
              </ul>

              <h2 className="text-2xl font-semibold mt-6">6. Personal Data</h2>
              <p className="mb-4">
                Personal data is processed in accordance with GDPR and LOPDGDD. See our <a href="/privacy-policy" className="underline">Privacy Policy</a> for full details.
              </p>

              <h2 className="text-2xl font-semibold mt-6">7. Cookies</h2>
              <p className="mb-4">
                We use cookies to improve your experience. You can manage your preferences or learn more by visiting our <a href="/cookies-policy" className="underline">Cookies Policy</a>.
              </p>

              <h2 className="text-2xl font-semibold mt-6">8. Termination</h2>
              <p className="mb-4">
                Slowork reserves the right to suspend or terminate user access in case of breach of these Terms and Conditions.
              </p>

              <h2 className="text-2xl font-semibold mt-6">9. Governing Law</h2>
              <p className="mb-4">
                These terms are governed by Spanish law. Any dispute shall be submitted to the courts of Sevilla, Spain.
              </p>

              <h2 className="text-2xl font-semibold mt-6">10. Dispute Resolution</h2>
              <p className="mb-4">
                Before resorting to court, users are encouraged to seek alternative dispute resolution such as arbitration or mediation.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TermsAndConditions;
